import { render, staticRenderFns } from "./PasesInternosAnular.vue?vue&type=template&id=4739930a&scoped=true&"
import script from "./PasesInternosAnular.vue?vue&type=script&lang=js&"
export * from "./PasesInternosAnular.vue?vue&type=script&lang=js&"
import style0 from "./PasesInternosAnular.vue?vue&type=style&index=0&id=4739930a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4739930a",
  null
  
)

export default component.exports